<template>
  <Slideover :visible="visible">
    <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
      <div class="flex items-start justify-between space-x-3">
        <h2 class="text-lg leading-7 font-medium">
          {{ title }}
        </h2>
        <div class="h-7 flex items-center">
          <button
            type="button"
            aria-label="Close panel"
            @click="$emit('toggle-slideover')"
            class="text-green-300 hover:text-white transition ease-in-out duration-150"
          >
            <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
    <div class="px-4 py-2">

      Choose the email template to send to:
      <br>
      {{ order.Name }} &lt;{{ order.Email }}&gt;

      <div class="flex mt-4 justify-around items-center">
        <Button
          @click-handler="send('invoice')"
          :disabled="loading"
        >
          Invoice
        </Button>
        <Button
          @click-handler="send('tracking')"
          :disabled="loading"
        >

          <span>Tracking</span>
        </Button>
      </div>

      <div class="mt-4 text-center">
        <div
          v-if="loading"
          class="flex space-x-2 justify-center items-center text-green-700"
        >
          <LoadingSpinner />
          <span>Sending ...</span>
        </div>
      </div>
      <div v-if="error" class="mt-4 text-center text-red-500">Something went wrong!</div>
    </div>
  </Slideover>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import Slideover from "@/components/layout/Slideover.vue";

const Emails = ApiFactory.get('emails');

export default {
  name: "EmailCustomer",
  components: {
    Button,
    Slideover
  },
  props: {
    title: {
      type: String,
      default: "Title"
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      error: false
    };
  },
  computed: {
    order() {
      return this.$store.getters["orders/get"]("order");
    },
  },
  methods: {
    send(template) {
      this.loading = true;
      Emails.send(this.order.SourceOrderNumber, template)
        .then(() => {
          this.$emit('toggle-slideover');
          this.reloadOrder();
        }).catch(() => {
          this.error = true;
        }).finally(() => {
          this.loading = false;
        });
    },
    reloadOrder() {
      this.$store.dispatch("orders/refreshOrder", this.order.SourceOrderNumber);
    },
  }
};
</script>
